"use client";
import { motion } from "framer-motion";
import HeroUI from "~/components/ui/hero";
import CardUI from "~/components/ui/card";

import {
  Anthropic,
  DeepSeek,
  Gemini,
  GLMV,
  Grok,
  OpenAI,
  Perplexity,
  Qwen,
  Codex,
  Minimax,
  Gemma,
  Kimi,
  Claude,
} from "@lobehub/icons";

interface LogoItem {
  name: string;
  component: React.FC<{
    size?: number;
    type?: "color" | "mono" | "text" | "combine" | "avatar";
  }>;
}

const Logos: LogoItem[] = [
  {
    name: "Grok",
    component: Grok,
  },
  {
    name: "DeepSeek",
    component: DeepSeek.Color,
  },

  {
    name: "Gemini",
    component: Gemini.Color,
  },
  {
    name: "ChatGPT",
    component: OpenAI,
  },
  {
    name: "Perplexity",
    component: Perplexity.Color,
  },
  {
    name: "Claude",
    component: Claude.Color,
  },
  {
    name: "Qwen",
    component: Qwen.Color,
  },
  {
    name: "MiniMax",
    component: Minimax.Color,
  },
  {
    name: "Kimi",
    component: Kimi.Color,
  },
  {
    name: "Gemma",
    component: Gemma.Color,
  },
  {
    name: "Anthropic",
    component: Anthropic,
  },
  {
    name: "GPT Codex",
    component: Codex.Color,
  },
  {
    name: "GLM",
    component: GLMV.Color,
  },
];

export default function ModelsSection() {
  const duplicatedData = [...Logos, ...Logos];
  const iconSize = 48;

  return (
    <HeroUI>
      <HeroUI.Container>
        <div className="w-full overflow-hidden" dir="ltr">
          <motion.div
            className="flex w-max gap-2 md:gap-4"
            animate={{ x: "-50%" }}
            transition={{
              repeat: Infinity,
              ease: "linear",
              duration: 30,
            }}
          >
            {duplicatedData.map((item, idx) => (
              <CardUI
                key={idx}
                variant="morph"
                className="flex w-40 shrink-0 gap-4 p-4 md:w-50 md:p-5"
                dir="ltr"
              >
                <div className="flex items-center gap-2">
                  {/* به جای تگ img، کامپوننت را رندر می‌کنیم */}
                  <item.component type="combine" size={iconSize} />
                  <h5 className="text-lg font-semibold">{item.name}</h5>
                </div>
              </CardUI>
            ))}
          </motion.div>
        </div>
      </HeroUI.Container>
    </HeroUI>
  );
}
